import { useState } from "react";
import { ActionButton, DisclosureBody, GuidePanel, GuideTextChips } from "./work-type-management.styles";

const operationalRules = [
  "결재 신청용 정책은 신청 From~To를 정책기간으로 유지합니다. 승인 전 지난 날짜에 로그가 없으면 0으로 계산하고, 승인 이후 실제 근무 기준 데이터를 생성합니다.",
  "기본 정책은 환경설정 From~To를 사용합니다. 시작일이 미래면 바로 적용하지 않고, 시작일이 도래한 시점부터 정책 기준 데이터를 생성합니다.",
  "시차출퇴근제와 탄력적 근로시간제는 적용기간 안의 예정 근무시간을 한 달 단위로 생성하며, 정책 변경 시 미래 예정 데이터만 삭제·재생성합니다.",
  "선택적 근로시간제는 예정 일별시간을 미리 만들지 않습니다. 출근 시 당일 데이터를 생성하고 적용 시작일의 일자를 기준으로 매월 정산 구간을 나눕니다.",
  "통계는 근무제 종류가 아니라 실제 저장된 출근·퇴근·휴게·인정근로 로그를 합산하며, 같은 주의 로그는 정책 변경과 관계없이 합산합니다."
];

export function AutomaticBreakGuidance({ enabled, valid, workMinutes, firstBreakMinutes, secondBreakMinutes }: { enabled: boolean; valid: boolean; workMinutes: number; firstBreakMinutes: number; secondBreakMinutes: number }) {
  return (
    <GuidePanel aria-label="자동 계산 예시">
      <h3>자동 계산 예시</h3>
      {enabled && valid ? (
        <GuideTextChips>
          <span>{workMinutes / 60}시간 근로 → 휴게 {firstBreakMinutes}분</span>
          <span>{(workMinutes * 2) / 60}시간 근로 → 휴게 {secondBreakMinutes}분</span>
        </GuideTextChips>
      ) : (
        <p>{enabled ? "유효한 휴게시간 기준을 입력하면 예시가 표시됩니다." : "자동 계산을 사용하면 입력한 기준에 따른 예시가 표시됩니다."}</p>
      )}
      <p>휴게시간은 고정 60분으로 저장하지 않고 근로시간을 기준으로 자동 산정합니다.</p>
      <ul>
        <li>환경설정에서는 휴게시간 산정 기준만 관리합니다.</li>
        <li>정확히 4시간 근무 시 휴게 미사용 요청 여부는 결재 신청의 해당 일자에서 별도로 선택·저장합니다.</li>
        <li>자동 산정된 휴게시간은 인정 근로시간과 분리하여 통계에 표시합니다.</li>
      </ul>
    </GuidePanel>
  );
}

export function OperationalGuidance() {
  const [expanded, setExpanded] = useState(false);
  return (
    <>
      <p>정책 구분과 적용기간에 따라 예정 데이터 생성 시점이 달라집니다. 저장 전에 전체 기준을 확인할 수 있습니다.</p>
      <div>
        <ActionButton type="button" aria-expanded={expanded} aria-controls="work-policy-operational-rules" onClick={() => setExpanded(current => !current)}>
          {expanded ? "전체 기준 닫기" : "전체 기준 보기"}
        </ActionButton>
      </div>
      {expanded && (
        <DisclosureBody id="work-policy-operational-rules" role="region" aria-label="적용·생성·통계 전체 기준">
          <ol>{operationalRules.map(rule => <li key={rule}>{rule}</li>)}</ol>
        </DisclosureBody>
      )}
    </>
  );
}
